import { render, staticRenderFns } from "./PriceListPage.vue?vue&type=template&id=6a2d31a7&scoped=true"
import script from "./PriceListPage.vue?vue&type=script&lang=ts"
export * from "./PriceListPage.vue?vue&type=script&lang=ts"
import style0 from "./PriceListPage.vue?vue&type=style&index=0&id=6a2d31a7&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2d31a7",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn,QTable,QSelect,QItem,QItemSection,QTd});
